import React from "react";
import { Breadcrumbs, BreadcrumbItem as AstryxBreadcrumbItem } from "@astryxdesign/core";
import styles from "./PageTopbar.module.css";

export interface PageTopbarProps {
  breadcrumbs: { label: string; href?: string }[];
}

/**
 * Breadcrumb bar using Astryx's Breadcrumbs component.
 *
 * Renders breadcrumbs via Astryx's Breadcrumbs/BreadcrumbItem, which handle
 * item/separator/current styling themselves; only the bar chrome is styled
 * here with Astryx neutral-theme tokens, so this MUST be rendered inside an
 * Astryx <Theme> scope.
 */
const PageTopbar = ({
  breadcrumbs,
}: PageTopbarProps): React.ReactElement => {
  return (
    <div className={styles.bar}>
      <Breadcrumbs label="Breadcrumb">
        {breadcrumbs.map((item, index) => (
          <AstryxBreadcrumbItem key={index} href={item.href}>
            {item.label}
          </AstryxBreadcrumbItem>
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default PageTopbar;
